export default __webpack_public_path__ + "static/media/pictogramBeaconFinancialPlanning40.4c02f417.svg";